import { render } from "./ApplicantPracticeTest.vue?vue&type=template&id=3aafc6cd"
import script from "./ApplicantPracticeTest.vue?vue&type=script&lang=ts"
export * from "./ApplicantPracticeTest.vue?vue&type=script&lang=ts"
script.render = render
/* custom blocks */
import block0 from "./ApplicantPracticeTest.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(script)


export default script